import { AMLSvg, CookieSvg, PrivacySvg, SupportIcon, TermsSvg } from './Icons';
import React from 'react';
import { msg } from '@lingui/macro';
export const MenuConfig = [
    {
        label: msg `Support`,
        onClick: () => {
            window.Intercom('showNewMessage');
        },
        Icon: <SupportIcon />,
    },
    {
        label: msg `Terms of Service`,
        href: 'https://www.swipelux.com/legal/terms-of-use',
        Icon: <TermsSvg />,
    },
    {
        label: msg `Privacy Policy`,
        href: 'https://www.swipelux.com/legal/privacy-policy',
        Icon: <PrivacySvg />,
    },
    {
        label: msg `AML Policy`,
        href: 'https://www.swipelux.com/legal/aml-policy',
        Icon: <AMLSvg />,
    },
    {
        label: msg `Cookies policy`,
        href: 'https://www.swipelux.com/legal/cookie-policy',
        Icon: <CookieSvg />,
    },
];
